import {LanguageService} from '../original-services/language.service';

export function SetupTranslateFactory(service: LanguageService) {
    return () => service.setup();
}
